import { render, staticRenderFns } from "./APIStatus.vue?vue&type=template&id=853cbe20&scoped=true&"
import script from "./APIStatus.vue?vue&type=script&lang=js&"
export * from "./APIStatus.vue?vue&type=script&lang=js&"
import style0 from "./APIStatus.vue?vue&type=style&index=0&id=853cbe20&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "853cbe20",
  null
  
)

export default component.exports